export enum LocalStorageKeys{
  SESSION = '_SESSION_',
}